import { UI_GroupContent, UI_GroupHeader, UI_GroupWrapper } from "../../../PanelStyle";
import { LuChevronDown, LuChevronUp } from "react-icons/lu";
import { memo, useState, useEffect, useCallback } from "react";
import { useAtom } from 'jotai';
import { currentProjectAtom } from "~/stores/ProjectStore";
import { MapData_Base } from "~/common/typescript/models/MapData";
import { layerSearchTextAtom } from "~/components/Map/Element/ElementStore";
import { Input } from "antd";
import styled from "styled-components";

const LayerGroup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentProject, setCurrentProject] = useAtom(currentProjectAtom);
  const [layers, setLayers] = useState<MapData_Base[]>([]);
  const [localSearchText, setLocalSearchText] = useState('');
  const [searchText, setSearchText] = useAtom(layerSearchTextAtom);
  const [filteredItems, setFilteredItems] = useState<MapData_Base[]>([]);

  const debouncedSetSearchText = useCallback(
    debounce((value: string) => {
      setSearchText(value);
    }, 300),
    []
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchText(value);
    debouncedSetSearchText(value);
  };

  const fetchData = async () => {
    // const elements = await ElementAPIs.remote_getPage({
    //   page: 1,
    //   pageSize: 10,
    //   project_id: currentProject?.id!,
    // });
    // setLayers(elements.results);
  };

  useEffect(() => {
    fetchData();
  }, [currentProject]);

  useEffect(() => {
    let result = layers;
    
    if (searchText.trim()) {
      const searchLower = searchText.toLowerCase().trim();
      result = result.filter((layer) => {
        const name = layer.name || '';
        return name.toLowerCase().includes(searchLower) || 
               layer.uuid.toLowerCase().includes(searchLower);
      });
    }
    
    setFilteredItems(result);
  }, [layers, searchText]);

  return (
    <UI_GroupWrapper>
      <UI_GroupHeader onClick={() => setIsOpen(!isOpen)}>
        <span>Lớp ({filteredItems.length})</span>
        <span>
          {isOpen ? <LuChevronDown /> : <LuChevronUp />}
        </span>
      </UI_GroupHeader>
      <UI_GroupContent style={{ display: isOpen ? 'block' : 'none' }}>
        <UI_SearchWrapper>
          <Input.Search
            placeholder="Tìm kiếm lớp..."
            value={localSearchText}
            onChange={handleSearchChange}
            allowClear
            onClick={(e) => e.stopPropagation()}
          />
        </UI_SearchWrapper>
        {
          filteredItems.length === 0 && (
            <div style={{ textAlign: 'center', padding: 20, color: '#666' }}>
              {searchText.trim() ? 'Không tìm thấy lớp' : 'Chưa có lớp bản đồ nào'}
            </div>
          )
        }
        {/* {
          filteredItems.map((layer) => {
            return <LayerItem key={layer.uuid} layer={layer} />;
          })
        } */}
      </UI_GroupContent>
    </UI_GroupWrapper>)
};

function debounce<T extends (...args: any[]) => any>(func: T, wait: number): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<T>) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), wait);
  };
}

export default memo(LayerGroup);

const UI_SearchWrapper = styled.div`
  padding: 4px 0;
  margin-bottom: 4px;
`;